import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { SpinnerModal } from 'Src/app/shared/modals/status-spinner/status-spinner.service';
import { IConfirmModalComponentData } from 'Src/ng2/shared/modals/confirm/confirm-modal.component';
import { ModalsService } from 'Src/ng2/shared/modals/modals.service';
import { DeleteSyncTool, IDeleteSyncToolPayload } from 'Src/ng2/store';

@Component({
  selector: 'other-tools-trash-can',
  template: require('./other-tools-trash-can.component.html'),
  styles: [require('./other-tools-trash-can.component.scss')],
})
export class OtherToolsTrashCanComponent implements OnInit {
  @Input() input: any;
  @Output() output = new EventEmitter();
  showTrash: boolean;

  constructor(
    private modalsService: ModalsService,
    private store: Store<any>,
    @Inject('SpinnerModal') private spinnerModal: SpinnerModal,
  ) {
    //
  }

  ngOnInit() {
    this.showTrash = this.input.column.data && this.input.column.meta.syncId;
  }

  openDeleteConfirmModal(): void {
    const confirmModalData: IConfirmModalComponentData = {
      title: 'Delete Sync',
      message: `Are you sure you want to delete the synced sheet: ${
        this.input.column.meta.name
      }? This action cannot be undone.`,
      confirmText: 'Delete',
    };
    this.modalsService
      .openConfirmModal(confirmModalData)
      .afterClosed()
      .subscribe((confirmed: false | true) => {
        if (confirmed) {
          this.deleteSync();
        }
      });
  }

  deleteSync() {
    this.spinnerModal.activateSpinner(`Deleting...`);
    const payload: IDeleteSyncToolPayload = {
      schoolId: this.input.column.meta.currentSchoolId,
      spreadsheetId: this.input.column.meta.sheetId,
    };
    this.store.dispatch(new DeleteSyncTool(payload));
  }
}
